let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kX7CO")).then(() => parcelRequire('gbuK8'));